// actions
export const PREVENT_UNLOAD = "prevent";
export const ALLOW_UNLOAD = "allow";

const state = {
  count: 0,
};

const getters = {
  uploadCount: (state) => state.count,
};

const actions = {
  [PREVENT_UNLOAD]({ commit }) {
    commit(PREVENT_UNLOAD);
  },
  [ALLOW_UNLOAD]({ commit }) {
    commit(ALLOW_UNLOAD);
  },
};

const mutations = {
  [PREVENT_UNLOAD](state) {
    ++state.count;
    window.onbeforeunload = (event) => {
      event.preventDefault();
      const message = "У Вас остались несохранённые изменения. Вы уверены, что хотите закрыть страницу?";
      event.returnValue = message;
      return message;
    };
  },
  [ALLOW_UNLOAD](state) {
    if (--state.count > 0) {
      return;
    }

    window.onbeforeunload = null;
    state.count = 0;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
